import { useLocale } from '@/contexts/LocaleContext';
import { useState, useEffect } from 'react';
import { Outlet, NavLink, Navigate, useLocation } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { ShieldCheck, Wallet, Wrench, Building } from 'lucide-react';
import api from '@/lib/api';
import { tenantHasVertical } from '@/lib/verticalAccess';

// S48 (9/N) — new top-level section, separate from "Mi Negocio"
// (BusinessHubLayout). Starts with just Punto de Venta (moved out of Mi
// Negocio per explicit request); future admin-only screens land here
// too, so this doesn't need to be rebuilt from scratch again.
// S76 (2/N-3/N) — Mesa de Servicio y Gestión condominal (Sprint 75 11/N y
// 12/N) llevaban sprints como backend puro sin ninguna pantalla; viven
// aquí porque son operación diaria del negocio, igual que POS.
export default function AdministracionHubLayout() {
  const { t } = useLocale();
  const location = useLocation();
  const [dict, setDict] = useState(null);

  useEffect(() => {
    api.get('/tenant/business/dictionary')
      .then(r => setDict(r.data || { vertical: 'generic' }))
      .catch(() => setDict({ vertical: 'generic' }));
  }, []);

  const TABS = [
    { key: 'pos', path: '/tenant/administracion/pos', labelKey: 'admin.pos', icon: Wallet, module: 'pos' },
  ];
  // Solo inmobiliaria (o secondary_verticals). Corp no desbloquea.
  if (tenantHasVertical(dict, 'real_estate')) {
    TABS.push({ key: 'warranty', path: '/tenant/administracion/mesa-de-servicio', labelKey: 'admin.warranty', icon: Wrench, module: 'real_estate_warranty' });
    TABS.push({ key: 'condo', path: '/tenant/administracion/condominal', labelKey: 'admin.condo', icon: Building, module: 'real_estate_condo' });
  }

  const { tabs: visibleTabs } = useHubTabs(TABS);

  if (location.pathname === '/tenant/administracion' || location.pathname === '/tenant/administracion/') {
    return <Navigate to="/tenant/administracion/pos" replace />;
  }

  return (
    <div className="space-y-5" data-testid="administracion-hub">
      <div>
        <h1 className="text-2xl font-bold text-[#0F172A] tracking-tight flex items-center gap-2">
          <ShieldCheck className="w-6 h-6" /> {t('nav.admin')}
        </h1>
        <p className="text-sm text-[#64748B] mt-1">{t('admin.sub')}</p>
      </div>
      <div className="flex gap-1 border-b border-[#E2E8F0] overflow-x-auto" data-testid="administracion-hub-tabs">
        {visibleTabs.map(tab => (
          <NavLink key={tab.key} to={tab.path} data-testid={`administracion-tab-${tab.key}`}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                isActive ? 'border-[#0F172A] text-[#0F172A]' : 'border-transparent text-[#64748B] hover:text-[#0F172A]'}`}>
            <tab.icon className="w-4 h-4" /> {tab.labelKey ? t(tab.labelKey) : tab.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
